import { useEffect, useState } from 'react';
import { Col, Layout, Row, Modal, Segmented, Typography, message, notification } from 'antd';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../store/hooks/hooks';
import { permissionProfileGestion, userSubMenu } from '../../../utils/functions';
import AddButton from '../../Molecules/AddButton/AddButton';
import Navbar from '../../Organisms/Navbar/Navbar';
import TaskTable from '../../Organisms/TaskTable/TaskTable';
import Filters from '../../Molecules/Filters/Filters';
import GeneralCardView from '../../Organisms/GeneralCardView/GeneralCardView';
import { ReactComponent as Plus } from '../../../res/svg/plus.svg';
import {
  getAllTasksFilters,
  selectTask,
  getUsersAssignedTo,
  getUsersCreatedBy,
  setShowTaskModal,
  deleteTask,
  setDeleteTask,
  cloneTask,
  clearNotDataTask,
  setShowTaskCard,
  selectShowTaskCard,
  setTaskFilters, exportTask,
} from '../../../store/slice/taskSlice';
import './TasksTemplate.less';
import CreateTaskModal from '../../Organisms/CreateTaskModal/CreateTaskModal';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import User from '../../../models/User';
import { rolPermission } from '../../../utils/functions'
import EmptyPlaceHolder from '../../Molecules/EmptyPlaceHolder/EmptyPlaceHolder';
import SectionIndicator, { subsections } from '../../Molecules/SectionIndicator/SectionIndicator';
import { ReactComponent as InfoCircle } from '../../../res/svg/info-circle-clonada.svg';

/**
 * @page TasksTemplate.tsx
 * @description TasksTemplate to assign Task.
 * @return { template }
 */

function TasksTemplate() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { confirm } = Modal;
  let navigate = useNavigate();
  const dispatch = useAppDispatch();
  const taskState = useAppSelector(selectTask);
  const [segmentedValue, setSegmentedValue] = useState<string | number>(
    'Tarjetas',
  );
  const showTaskCard = useAppSelector(selectShowTaskCard);
  const { Text } = Typography;
  const [showCloneTask, setShowCloneTask] = useState(false);

  //@ts-ignore
  const currentUser: User = JSON.parse(localStorage.getItem('currentUser'))

  const filtros = useAppSelector(state => state.task.filtros);

  const permissionCreateTask = () =>{
    let createTask = false;
    if(currentUser.rol !== null){
      if(currentUser.rol.permiso === rolPermission.COORDINACION || currentUser.rol.permiso === rolPermission.AUTOGESTION){
        createTask = true
      }
    }
    return createTask;
  }

  const showTaskModal = (show: boolean) => {
    dispatch(setShowTaskModal(show));
  };

  const itemsCallback = (item: string) => {
    userSubMenu(item, navigate, dispatch);
  };

  const onChangeSegmented = (item: any) => {
    setSegmentedValue(item);
    if (item === 'Tarjetas') {
      //se setea query params para mostrar el componente de las tarjetas
      searchParams.set('display','tarjetas');
      setSearchParams(searchParams);
      dispatch(setShowTaskCard(true));
      dispatch(setTaskFilters({ page: 1, pageSize: 20}));
    } else {
      searchParams.set('display','tabla');
      setSearchParams(searchParams);
      dispatch(setShowTaskCard(false));
      dispatch(setTaskFilters({ page: 1, pageSize: 20}));
    }
  };


  useEffect(() => {
    dispatch(getAllTasksFilters())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showCloneTask, filtros]);


  useEffect(() => {
    //solo perfil gestion pueden ingresar
    permissionProfileGestion(navigate)
    /**Query params para poder visualizar que componente mostrar si tabla o tarjetas*/
    const display = searchParams.get('display');
    dispatch(setShowTaskCard(display !== 'tabla'));

    if(display !== 'tabla'){
      setSegmentedValue('Tarjetas')
    } else {
      setSegmentedValue('Tabla')
    }
    //Trae todas las tareas
    dispatch(getAllTasksFilters())
    dispatch(getUsersAssignedTo());
    dispatch(getUsersCreatedBy());
    //se limpia el estado state.notDataTask
    dispatch(clearNotDataTask());
    //limpiar filtros
    limpiarFiltros();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const limpiarFiltros = () =>{
    dispatch(setTaskFilters({
      ordenarPor: undefined,
      tipoFecha:  undefined,
      fechaDesde: undefined,
      fechaHasta: undefined,
      estado:     undefined,
      creadasPor: [],
      tipoTarea: [],
      search: undefined,
      tareaUsuarioEstado: [],
      usuariosAsignados: [],
      page: 1,
      pageSize: 20,
    }))
  }

  const taskDelete = (taskId: number) =>{
    confirm({
      title: 'Eliminar Tarea',
      icon: <ExclamationCircleOutlined style={{color:'#FF4D4F'}}/>,
      content: (
        <>
          ¿Confirmas que deseas eliminar la tarea? <br /> Recuerda que esta acción es irreversible.
        </>
      ),
      okText: 'Eliminar tarea',
      okType: 'danger',
      cancelText: 'Cancelar',

      onOk() {
        dispatch(deleteTask(taskId)).then((response: any) => {
          if (response.payload.status) {
            dispatch(setDeleteTask(taskId));
            message.success('La tarea fue eliminada con éxito.');
          } else {
            message.error('Error,Tipo de tarea ligada a una tarea o rol.');
          }
        });
      },
    });
  }

  const cloneTaskAction = (taskId: number) =>{
    dispatch(cloneTask(taskId)).then((response: any) =>{
      if (response.payload.status) {
        //se usa para actualizar la pantalla y mostrar la tarea clonada
        setShowCloneTask(!showCloneTask);
        message.success('La tarea fue clonada con éxito.');
        notification.error({
          message: null,
          icon: <InfoCircle />,
          description: 'Las geometrías pueden demorar en actualizarse. Te recomendamos actualizar tu navegador en unos minutos.',
          style: {
            borderRadius: 8
          },
          duration: 5
        })
      } else {
        message.error('Error, no se pudo clonar la Tarea');
      }
    })
  }

  const exportTaskAction = (taskId: number, titulo: string) => {
    dispatch(exportTask(taskId)).then((response) =>{
      if(!response.payload){
        return;
      }
      const url = window.URL.createObjectURL(response.payload);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = `${titulo}.kmz`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    }).catch(() => {
      message.error('Error al exportar la Tarea');
    });
  }

  return (
    <Layout>
      <Navbar showItems={true} currentScreen={'tareas'} subsection={'gestion'} itemsCallback={itemsCallback} />
      <SectionIndicator subsection={subsections.tareas} />
      <Layout className="tp-task__layout">
        <div style={{
          display: 'flex',
          justifyContent: 'space-between'
        }}>
          {permissionCreateTask() ?
            <AddButton
              icon={<Plus />}
              title="Crear Tarea"
              showModal={showTaskModal}
            /> : <div />
          }
          <Col span={5} offset={7} className="tp-tasks__segmented__view">
            <Text className="tp-tasks__segmented__label">Vista de:</Text>
            <Segmented
              className="tp-tasks__segmented"
              options={['Tarjetas', 'Tabla']}
              size={'large'}
              value={segmentedValue}
              onChange={onChangeSegmented}
            />
          </Col>
        </div>
        <Filters />
        <Row className="tp-tasks__content">
          {
            taskState.task && taskState.task.length > 0 ?
            (
              <Col span={24}>
              {showTaskCard ? (
              <GeneralCardView
                data={taskState.task}
                actionExportTask={exportTaskAction}
                deleteTaskModal={taskDelete}
                actionCloneTask={cloneTaskAction}
              />
              ) : (
              <TaskTable
                data={taskState.task}
                actionExportTask={exportTaskAction}
                deleteTaskModal={taskDelete}
                actionCloneTask={cloneTaskAction}
              />
              )}
              </Col>
            ) : <EmptyPlaceHolder />
          }
        </Row>
        <Row>
          <Col>
            <CreateTaskModal />
          </Col>
        </Row>
      </Layout>
    </Layout>
  );
}

export default TasksTemplate;
